import gql from "graphql-tag";

export const DELETE_RESOURCES_ON_MATERIAL_DATAS = gql`
  mutation deleteResourcesOnMaterialDatas($where: [String]!) {
    deleteResourcesOnMaterialDatas(where: $where)
  }
`;